import { qk, STALE_TIME, type TenantKey } from "@secretaa/sdk-react";
import { WorkspaceId } from "@secretaa/kernel";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { api } from "./api.ts";

export function useSession() {
  return useQuery({ queryKey: qk.me(), queryFn: api.session, staleTime: STALE_TIME.session, retry: false });
}

/** Workspace hiện tại + key tenant (workspaceId + scopeVersion) cho mọi query của workspace (W.2). */
export function useCurrentWorkspace(): { workspaceId: string; tenant: TenantKey; role: "owner" | "admin" | "member"; name: string } | null {
  const { workspaceId } = useParams();
  const session = useSession();
  const m = session.data?.memberships.find((x) => x.workspaceId === workspaceId);
  if (!workspaceId || !m) return null;
  return { workspaceId, tenant: { workspaceId: WorkspaceId(workspaceId), accessScopeVersion: m.scopeVersion }, role: m.role, name: m.workspaceName };
}

export const canManage = (role: string | undefined) => role === "owner" || role === "admin";
